import React, { useContext, useState } from 'react';
import { Button } from 'components';
import styled from 'styled-components';
import { FirebaseContext } from 'context';
import { Container, Title, Card, Label, FormSelect } from '../Shared';

const setInitialState = () => ({
  selectedUsers: [],
  sessionId: ''
});

function SessionAccess({ users, sessions, customDropdownMenuStyles }) {
  const { firebase } = useContext(FirebaseContext);
  const [formValues, setFormValues] = useState(setInitialState());
  const [grantingUserSessionAccess, setGrantingUserSessionAccess] =
    useState(false);
  const [removingUserSessionAccess, setRemovingUserSessionAccess] =
    useState(false);

  const handleGrantUserSessionAccess = async () => {
    try {
      const { selectedUsers, sessionId } = formValues;
      if (selectedUsers.length && sessionId) {
        setGrantingUserSessionAccess(true);
        await firebase.admin.grantUserSessionAccess({
          uids: selectedUsers.map((_user) => _user.value.uid),
          sessionId: sessionId.value
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setGrantingUserSessionAccess(false);
      setFormValues(setInitialState());
    }
  };

  const handleRemoveUserSessionAccess = async () => {
    try {
      const { selectedUsers, sessionId } = formValues;
      if (selectedUsers.length && sessionId) {
        setRemovingUserSessionAccess(true);
        await firebase.admin.removeUserSessionAccess({
          uids: selectedUsers.map((_user) => _user.value.uid),
          sessionId: sessionId.value
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setRemovingUserSessionAccess(false);
      setFormValues(setInitialState());
    }
  };

  return (
    <Container>
      <Title>Session Access</Title>
      <Card>
        <div>
          <Label>Select Users</Label>
          <FormSelect
            isMulti
            value={formValues.selectedUsers}
            onChange={(selectedUsers) =>
              setFormValues((currentState) => ({
                ...currentState,
                selectedUsers
              }))
            }
            placeholder="Select"
            styles={customDropdownMenuStyles()}
            options={users}
          />
        </div>
        <div>
          <Label>Session ID</Label>
          <FormSelect
            value={formValues.sessionId}
            onChange={(sessionId) =>
              setFormValues((currentState) => ({ ...currentState, sessionId }))
            }
            placeholder="Select"
            styles={customDropdownMenuStyles()}
            options={sessions}
          />
        </div>
        <ButtonWrapper>
          <Button
            type="button"
            loading={grantingUserSessionAccess}
            disabled={!formValues.selectedUsers || !formValues.sessionId}
            style={{ margin: '0 auto', width: '120px' }}
            changeColorWhenDisabled={false}
            onClick={handleGrantUserSessionAccess}>
            Grant
          </Button>
          <Button
            type="button"
            loading={removingUserSessionAccess}
            disabled={!formValues.selectedUsers || !formValues.sessionId}
            style={{ margin: '0 auto', width: '120px' }}
            changeColorWhenDisabled={false}
            onClick={handleRemoveUserSessionAccess}>
            Remove
          </Button>
        </ButtonWrapper>
      </Card>
    </Container>
  );
}

const ButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 0.75rem auto 0;

  > button {
    width: 110px;
  }
`;

export default SessionAccess;
